
<div class="showcase-card-more-cards" v-if="cards.length > 0">
  <align class="header" flex>
    <h4 class="secondary-font">More in this collection</h4>

    <icon-link
      :as="isPublic ? 'nuxt-link' : 'router-link'"
      :to="`/showcase/${card.uid}?collectionId=${card.collectionId}`"
    >
      View all
    </icon-link>
  </align>

  <div v-if="isPublic" class="grid medium-up">
    <showcase-card
      v-for="card in cards"
      :key="card.id"
      as="nuxt-link"
      :card="card"
      :to="getCardTo(card.id)"
    />
  </div>

  <div class="list" :class="{ 'medium-down': isPublic }">
    <card-list-item
      v-for="card in cards"
      :key="card.id"
      :card="card"
      :to="getCardTo(card.id)"
      :as="isPublic ? 'nuxt-link' : 'router-link'"
    />
  </div>
</div>
